const PER_PAGE_DATA = [
  { id: "1", name: "10", value: 10 },
  { id: "2", name: "15", value: 15 },
  { id: "3", name: "25", value: 25 },
  { id: "4", name: "50", value: 50 },
];

const BLOCKED_TABLE_COLS = ["#", "Actions", "Action"];
export { PER_PAGE_DATA, BLOCKED_TABLE_COLS };
